import { LinkPreview_linkPreview } from 'chat/queries/__generated__/LinkPreview';

export interface LinkPreviewType {
  title: string;
  description: string | null;
  url: string;
  image: string | null;
  image_width?: number | null;
  image_height?: number | null;
  rich_content_type: string | null;
  rich_content_url: string | null;
  downloadPreview: any; // I don't know yet what is this
  addedAtUnix?: number; // Just used in the UI for sorting
}

export function fromLinkPreviewToLinkPreviewGQL(lp: LinkPreviewType) {
  return {
    title: lp.title,
    description: lp.description,
    url: lp.url,
    imageUrl: lp.image,
    imageWidth: lp.image_width,
    imageHeight: lp.image_height,
    richContentType: lp.rich_content_type,
    richContentUrl: lp.rich_content_url,
  };
}

export function fromLinkPreviewGQLToLinkPreview(lp: LinkPreview_linkPreview) {
  return {
    title: lp.title,
    description: lp.description,
    url: lp.url,
    image: lp.imageUrl,
    image_width: lp.imageWidth,
    image_height: lp.imageHeight,
    rich_content_type: lp.richContentType,
    rich_content_url: lp.richContentUrl,
    downloadPreview: null,
  };
}
